import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=976f366a&scoped=true"
import script from "./integralDetails.vue?vue&type=script&lang=js"
export * from "./integralDetails.vue?vue&type=script&lang=js"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=976f366a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976f366a",
  null
  
)

export default component.exports